import { Container } from "./style";
export const Bonds = ({ data, title, className }) => {
  return (
    <Container>
      {title && 
        <div className={`title-bonds ${className}`}>
          <p className={className}>{title}</p>
        </div>
      }
      <div className="bonds-grid">
        {data.map((bond, index) => (
          <>
          {bond &&
            <div className="card" key={`bond${index}`}>
              <div className="card-content">
                <h2>{bond?.papel}</h2>
                <div className="bond-info">
                  <p>
                    {bond?.ultimo}
                  </p>
                </div>
                <p className="last-value">{`Último valor obtenido al ${bond?.data} - ${bond?.hora}`}</p>
                <a className="button" href={`/economia/divisas-acciones-bonos/bonos/${bond?.papel.replace(/\s+/g, '')}`}>Ver</a>
              </div>
            </div>
          }
          </>
        ))}
      </div>
    </Container>
  );
};
